import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '../../classes/user';
import { Location } from '@angular/common';

import { LoginService } from '../../services/login.service';
import { Realm } from '../../classes/realm';

@Component({
  selector: 'app-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
  standalone: false
})
export class HeaderComponent {
  private readonly login = inject(LoginService);
  private readonly router = inject(Router);
  private readonly location = inject(Location);

  public get user(): User { return this.login.user; }
  public get showNavigation() { return !!this.user; }

  public get isProfileManagementSelected(): boolean {
    return this.location.path().includes(`/admin/edit/account/${this.user?.adminId}`);
  }

  public logout(): void {
    this.login.logout();
    this.router.navigate(['login']);
  }

  public async switchRealm(realm: Realm): Promise<void> {
    return this.login.selectRealm(realm.id, true);
  }
}
